import { render, staticRenderFns } from "./YeuCauForm.vue?vue&type=template&id=72dc951a&scoped=true"
import script from "./YeuCauForm.vue?vue&type=script&lang=js"
export * from "./YeuCauForm.vue?vue&type=script&lang=js"
import style0 from "./YeuCauForm.vue?vue&type=style&index=0&id=72dc951a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dc951a",
  null
  
)

export default component.exports